export const SET_WIDGET_TITLE = 'SET_WIDGET_TITLE';
export const SET_RING_TREES = 'SET_RING_TREES';
export const SET_RING_TREE = 'SET_RING_TREE';
export const SET_RING_TREE_TARGETS = 'SET_RING_TREE_TARGETS';
export const SET_RING_TREE_REFERENCES = 'SET_RING_TREE_REFERENCES';
export const SET_CHECK_REFERENCES_TEXT = 'SET_CHECK_REFERENCES_TEXT';
export const SET_USER_VISIBLE_COLUMNS = 'SET_USER_VISIBLE_COLUMNS';